import { Injectable} from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

import { AppConfig } from '../config/app.config';
import { IReturnObject } from '../shared/return-object.model';
import { MultiPartBE } from './shared/multipart-part.model';

@Injectable()
export class MultiPartService {
    constructor(private config: AppConfig, private http: Http) { }

    private apiUrl: string = this.config.get('apiUrl') + 'Part';

    deleteMultiPart(partId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeleteMultiPart/?partId=${partId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getMultiPart(partId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetMultiPart/?partId=${partId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getConsistingPartsForPart(partNo: string): Observable<IReturnObject> {
        return this.http.get( `${this.apiUrl}/GetConsistingPartsForPart/?partNo=${partNo}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    updateMultiPart(part: MultiPartBE): Observable<IReturnObject> {
        let headers: Headers = new Headers();
        headers.append('Content-Type', 'application/json'); 
        headers.append('Accept', 'application/json');
        let body = JSON.stringify(part);
        let options = new RequestOptions({ headers: headers });

        return this.http.post(`${this.apiUrl}/UpdateMultiPart`, body, options)
            .map((response: Response) => <IReturnObject>response.json());
    }
}



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/multipart-part/multipart-part.service.ts